import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "dateRangePicker",
    "dateRangePickerDate",
    "dateRangePickerTitle"
  ];

  connect() {
    this.dataRangePicker();
  }

  filter(e) {
    e.preventDefault();
    this.filters = $(e.srcElement).serialize();

    $.ajax({
      url: `/financial/cashflow?${this.filters}`,
      dataType: "script"
    });
  }

  get dates() {
    return JSON.parse(this.data.get("dates"));
  }

  set dates(value) {
    this.data.set("dates", JSON.stringify(value));
  }

  get filters() {
    return JSON.parse(this.data.get("filters"));
  }

  set filters(value) {
    this.data.set("filters", JSON.stringify(value));
  }

  dataRangePicker() {
    const start = moment();
    const end = moment();

    const callback = (t, e, a) => {
      let r = "",
        o = "";
      e - t < 100 || "Hoje" == a
        ? ((r = "Hoje:"), (o = t.format("D [de] MMMM")))
        : (o = t.format("D [de] MMMM") + " - " + e.format("D [de] MMMM")),
        $(this.dateRangePickerDateTarget).html(o),
        $(this.dateRangePickerTitleTarget).html(r);

      $.ajax({
        url: `/financial/cashflow?by_date[starts_at]=${t.unix()}&by_date[ends_at]=${e.unix()}`,
        dataType: "script"
      });
    };

    $(this.dateRangePickerTarget).daterangepicker(
      {
        startDate: start,
        endDate: end,
        ranges: {
          Hoje: [moment(), moment()],
          "Essa semana": [moment().startOf("week"), moment().endOf("week")],
          "Esse mês": [moment().startOf("month"), moment().endOf("month")],
          "Últimos 30 dias": [moment().subtract(29, "days"), moment()]
        },
        locale: {
          cancelLabel: "Cancelar",
          applyLabel: "Aplicar",
          customRangeLabel: "Escolher período",
          daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"]
        }
      },
      callback
    );

    callback(start, end);
  }
}
